// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import ProgramClock from "././assets/Clock.png";
import ProgramCheckMark from "././assets/program-check-mark.svg";
var REWARDS_PROGRAMS_ASSETS_MAP = {
  REWARDS_PROGRAM_CLOCK: ProgramClock,
  REWARDS_PROGRAM_CHECK_MARK: ProgramCheckMark
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(REWARDS_PROGRAMS_ASSETS_MAP);
};

// src/pages/reward-program-landing-page/reward-program-landing-page.component.tsx
import React15 from "react";
import {
  FullPageError,
  LoadingIndicator
} from "@leagueplatform/web-common-components";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES3,
  ProgramBanner as ProgramBanner4,
  ProgramLayout,
  ProgramRichText as ProgramRichText6,
  ProgramTabs
} from "@leagueplatform/health-journey-common";

// src/hooks/use-reward-program-landing-page.hook.ts
import { useParamsLegacy as useParams } from "@leagueplatform/routing";
import { useGetUserProfile } from "@leagueplatform/health-journey-common";

// src/hooks/use-get-user-health-campaign-by-id.hook.ts
import {
  GET_USER_CAMPAIGNS_MESSAGE_TYPE,
  getUserHealthCampaignById
} from "@leagueplatform/health-journey-api";
import { useQuery } from "@tanstack/react-query";
import { captureError } from "@leagueplatform/observability";
function useGetUserHealthCampaignById(userHealthCampaignId, includeUserHealthActivities, includeUserHealthCampaign) {
  return useQuery(
    [GET_USER_CAMPAIGNS_MESSAGE_TYPE, userHealthCampaignId],
    () => getUserHealthCampaignById(
      userHealthCampaignId,
      includeUserHealthActivities,
      includeUserHealthCampaign
    ),
    {
      staleTime: Infinity,
      onError: (error) => {
        captureError(
          new Error(
            `Failed to get reward program(id: ${userHealthCampaignId}): ${error}`
          )
        );
      }
    }
  );
}

// src/hooks/use-reward-program-landing-page.hook.ts
function useRewardProgramLandingPage() {
  const { userHealthCampaignId } = useParams();
  const { isLoading, isFetching, data, isError, error } = useGetUserHealthCampaignById(userHealthCampaignId, true, true);
  const { isLoading: isLoadingProfile, isError: isProfileError } = useGetUserProfile();
  return {
    isError: isError || isProfileError,
    isLoading: isFetching || isLoading || isLoadingProfile,
    rewardProgram: data == null ? void 0 : data.data,
    error
  };
}

// src/pages/reward-program-landing-page/reward-program-landing-page.component.tsx
import { Box as Box7, Responsive as Responsive2 } from "@leagueplatform/genesis-core";

// src/components/reward-program-overview-tab/reward-program-overview-tab.component.tsx
import {
  Button,
  Icon,
  StackLayout,
  StatusBanner,
  TextAction,
  styled
} from "@leagueplatform/genesis-core";
import {
  JOURNEY_ROUTES,
  ProgramAchievements,
  ProgramRichText,
  ProgramSponsor,
  ProgramRules
} from "@leagueplatform/health-journey-common";
import { useIntl } from "@leagueplatform/locales";
import React, { useEffect } from "react";
import { LinkLegacy as Link } from "@leagueplatform/routing";
import { captureError as captureError2 } from "@leagueplatform/observability";
import { EVENT_NAME, trackAnalyticsEvent } from "@leagueplatform/analytics";
var StyledLink = styled(TextAction, {
  fontSize: "inherit",
  lineHeight: "inherit"
});
function RewardProgramOverviewTab({
  campaignId,
  campaign,
  status,
  isVisible
}) {
  var _a, _b, _c;
  const { formatMessage } = useIntl();
  const { programRules } = campaign.data;
  const sponsoredByAttributes = (_a = campaign.data.contentProviderAttributes) == null ? void 0 : _a.componentAttributes;
  const disclaimerAttributes = (_b = campaign.data.bannerComponentAttributes) == null ? void 0 : _b.componentAttributes;
  const achievementAttributes = (_c = campaign.data.achievementsComponentAttributes) == null ? void 0 : _c.componentAttributes;
  useEffect(() => {
    if (!programRules && !sponsoredByAttributes && !disclaimerAttributes && !achievementAttributes) {
      captureError2(
        new Error(
          `Reward program(id:${campaignId}) overview data isn't provided`
        )
      );
    }
  }, [
    achievementAttributes,
    campaignId,
    disclaimerAttributes,
    programRules,
    sponsoredByAttributes
  ]);
  useEffect(() => {
    if (isVisible) {
      trackAnalyticsEvent(EVENT_NAME.SCREEN_LOADED, {
        ["product_area" /* PRODUCT_AREA */]: "health journey" /* PRODUCT_AREA_HEALTH_JOURNEY */,
        ["sub_product_area" /* SUB_PRODUCT_AREA */]: "reward programs" /* SUB_PRODUCT_AREA_REWARD_PROGRAMS */,
        ["screen_name" /* SCREEN_NAME */]: "health campaign detail overview" /* SCREEN_NAME_HEALTH_CAMPAIGN_DETAIL_OVERVIEW */,
        ["health_campaign_name" /* CAMPAIGN_NAME */]: campaign.data.name,
        ["health_campaign_id" /* CAMPAIGN_ID */]: campaignId,
        ["health_campaign_type" /* CAMPAIGN_TYPE */]: campaign.data.type,
        ["health_campaign_status" /* CAMPAIGN_STATUS */]: status
      });
    }
  }, [campaign.data.name, campaign.data.type, campaignId, isVisible, status]);
  return /* @__PURE__ */ React.createElement(StackLayout, { spacing: "$twoAndHalf", css: { marginTop: "$two" } }, /* @__PURE__ */ React.createElement(
    ProgramRichText,
    {
      options: {
        a: {
          component: StyledLink,
          props: {
            target: "_blank",
            onClick: (e) => {
              trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
                ["product_area" /* PRODUCT_AREA */]: "health journey" /* PRODUCT_AREA_HEALTH_JOURNEY */,
                ["sub_product_area" /* SUB_PRODUCT_AREA */]: "reward programs" /* SUB_PRODUCT_AREA_REWARD_PROGRAMS */,
                ["screen_name" /* SCREEN_NAME */]: "health campaign detail overview" /* SCREEN_NAME_HEALTH_CAMPAIGN_DETAIL_OVERVIEW */,
                ["detail" /* DETAIL */]: e.currentTarget.innerHTML
              });
            }
          }
        }
      },
      richText: campaign.data.richTextDescription
    }
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      as: Link,
      to: JOURNEY_ROUTES.getRewardProgramProgress(campaignId),
      onClick: () => {
        trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
          ["product_area" /* PRODUCT_AREA */]: "health journey" /* PRODUCT_AREA_HEALTH_JOURNEY */,
          ["sub_product_area" /* SUB_PRODUCT_AREA */]: "reward programs" /* SUB_PRODUCT_AREA_REWARD_PROGRAMS */,
          ["screen_name" /* SCREEN_NAME */]: "health campaign detail overview" /* SCREEN_NAME_HEALTH_CAMPAIGN_DETAIL_OVERVIEW */,
          ["detail" /* DETAIL */]: "view all activities" /* DETAIL_VIEW_ALL_ACTIVITIES */
        });
      }
    },
    formatMessage({ id: "VIEW_THE_ACTIVITIES" })
  ), programRules && /* @__PURE__ */ React.createElement(ProgramRules, { programRules }), sponsoredByAttributes && /* @__PURE__ */ React.createElement(
    ProgramSponsor,
    {
      image: sponsoredByAttributes.logotype,
      sponsorName: sponsoredByAttributes.name
    }
  ), achievementAttributes && /* @__PURE__ */ React.createElement(
    ProgramAchievements,
    {
      title: achievementAttributes.title,
      text: achievementAttributes.text,
      badgeUrl: achievementAttributes.iconUrl
    }
  ), disclaimerAttributes && /* @__PURE__ */ React.createElement(
    StatusBanner,
    {
      css: { width: "100%", backgroundColor: "$surfaceBackgroundTertiary" },
      status: "neutral",
      icon: /* @__PURE__ */ React.createElement(Icon, { size: "$one", icon: disclaimerAttributes.iconUrl }),
      title: disclaimerAttributes.title
    },
    /* @__PURE__ */ React.createElement(ProgramRichText, { richText: disclaimerAttributes.richText })
  ));
}

// src/pages/reward-program-landing-page/reward-program-landing-page.component.tsx
import { useIntl as useIntl11 } from "@leagueplatform/locales";

// src/components/reward-program-progress-tab/reward-program-progress-tab.component.tsx
import { EVENT_NAME as EVENT_NAME4, trackAnalyticsEvent as trackAnalyticsEvent4 } from "@leagueplatform/analytics";
import { Box as Box4, StackLayout as StackLayout11 } from "@leagueplatform/genesis-core";
import { captureError as captureError4 } from "@leagueplatform/observability";

// src/components/activity-list/activity-list.component.tsx
import { StackLayout as StackLayout6 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";

// src/components/activity-list-section/activity-list-section.component.tsx
import React5 from "react";
import {
  Box,
  HeadingText as HeadingText2,
  StackLayout as StackLayout5,
  UtilityText as UtilityText3,
  queryHelpers as queryHelpers2,
  useMediaQuery as useMediaQuery2
} from "@leagueplatform/genesis-core";

// src/components/reward-program-activity-card/reward-program-activity-card.component.tsx
import {
  Icon as Icon3,
  StackLayout as StackLayout4,
  queryHelpers,
  useMediaQuery,
  Card,
  useClickableCard
} from "@leagueplatform/genesis-core";
import { JOURNEY_ROUTES as JOURNEY_ROUTES2 } from "@leagueplatform/health-journey-common";

// src/components/activity-card-content/activity-card-content.component.tsx
import React3, { forwardRef } from "react";
import {
  HeadingText,
  StackLayout as StackLayout3,
  UtilityText as UtilityText2,
  TextAction as TextAction2
} from "@leagueplatform/genesis-core";
import {
  USER_HEALTH_CAMPAIGN_STATUS
} from "@leagueplatform/health-journey-api";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { IconText } from "@leagueplatform/web-common-components";

// src/components/activity-date/activity.date.component.tsx
import React2 from "react";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import { Icon as Icon2, StackLayout as StackLayout2, UtilityText } from "@leagueplatform/genesis-core";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import {
  useGetUserProfile as useGetUserProfile2
} from "@leagueplatform/health-journey-common";

// src/utils/get-activity-group.ts
import { UserHealthActivityStatus } from "@leagueplatform/health-journey-common";
var GetActivityGroup = (status) => {
  let isCompleted = false;
  let isActive = false;
  let isMissed = false;
  switch (status) {
    case UserHealthActivityStatus.EXPIRED:
    case UserHealthActivityStatus.REMOVED:
      isMissed = true;
      break;
    case UserHealthActivityStatus.COMPLETED:
      isCompleted = true;
      break;
    case UserHealthActivityStatus.ACTIVE:
    case UserHealthActivityStatus.UPCOMING:
      isActive = true;
      break;
    default:
  }
  return { isCompleted, isActive, isMissed };
};

// src/components/activity-date/activity.date.component.tsx
function ActivityDate({
  startDate,
  endDate,
  status,
  showDate
}) {
  const { formatDate, formatMessage } = useIntl2();
  const { data: userProfileData } = useGetUserProfile2();
  const { defaultTimezone } = userProfileData || {};
  const { isCompleted, isActive, isMissed } = GetActivityGroup(status);
  if (isCompleted || !startDate && !endDate || !showDate && !isMissed)
    return null;
  return /* @__PURE__ */ React2.createElement(StackLayout2, { orientation: "horizontal", spacing: "$quarter" }, /* @__PURE__ */ React2.createElement(
    Icon2,
    {
      css: { filter: `saturate(${isMissed ? 0 : 1})` },
      icon: handleStaticAsset(
        "REWARDS_PROGRAM_CLOCK" /* REWARDS_PROGRAM_CLOCK */
      ),
      size: "$one"
    }
  ), /* @__PURE__ */ React2.createElement(
    UtilityText,
    {
      css: {
        typography: "$bodyTwo",
        color: isMissed ? "$onSurfaceTextSubdued" : "inherit",
        lineHeight: 1.2
      }
    },
    isActive && `${formatMessage(
      { id: "START_DAY_AT_TIME" },
      {
        day: formatDate(startDate, {
          month: "long",
          day: "numeric",
          year: "numeric",
          timeZone: defaultTimezone
        })
      }
    )} \u2022 ${formatMessage(
      { id: "END_DAY_AT_TIME" },
      {
        day: formatDate(endDate, {
          month: "long",
          day: "numeric",
          year: "numeric",
          timeZone: defaultTimezone
        })
      }
    )}`,
    isMissed && formatMessage(
      { id: "ENDED_DAY_AT_TIME" },
      {
        day: formatDate(endDate, {
          month: "long",
          day: "numeric",
          year: "numeric",
          timeZone: defaultTimezone
        })
      }
    )
  ));
}

// src/components/activity-card-content/activity-card-content.component.tsx
var ActivityCardContent = forwardRef(
  ({
    activity,
    showDate,
    relatedCampaign,
    clickAction
  }, ref) => {
    var _a, _b, _c;
    const { formatMessage, $tmap } = useIntl3();
    const { linkedEntity } = activity;
    const { isCompleted, isMissed, isActive } = GetActivityGroup(
      activity.status
    );
    const message = $tmap({
      completed: "REWARD_POINTS_EARNED",
      missed: "REWARD_POINTS_MISSED",
      otherwise: "REWARD_POINTS"
      // eslint-disable-next-line no-nested-ternary
    })(isCompleted ? "completed" : isMissed ? "missed" : "otherwise");
    const hidePoints = relatedCampaign.status === USER_HEALTH_CAMPAIGN_STATUS.COMPLETED && isActive;
    const showRequired = activity.required && !isCompleted;
    return /* @__PURE__ */ React3.createElement(
      StackLayout3,
      {
        spacing: "$half",
        orientation: "vertical",
        verticalAlignment: "top"
      },
      /* @__PURE__ */ React3.createElement(HeadingText, { level: "6", size: "xs" }, /* @__PURE__ */ React3.createElement(
        TextAction2,
        {
          onClick: clickAction,
          ref,
          as: "button",
          css: {
            all: "inherit",
            "&:hover": {
              textDecoration: "none"
            }
          }
        },
        activity.name
      )),
      !hidePoints && /* @__PURE__ */ React3.createElement(
        IconText,
        {
          iconProps: {
            icon: ((_a = activity.reward) == null ? void 0 : _a.iconUrl) || "",
            css: { filter: `saturate(${isMissed ? 0 : 1})` }
          },
          text: /* @__PURE__ */ React3.createElement(
            UtilityText2,
            {
              css: {
                typography: "$bodyTwo",
                color: isMissed ? "$onSurfaceTextSubdued" : "inherit"
              }
            },
            /* @__PURE__ */ React3.createElement(
              UtilityText2,
              {
                css: {
                  paddingInlineEnd: "$quarter",
                  typography: "$bodyTwo",
                  color: isCompleted ? "$onSurfaceTextSuccess" : "inherit",
                  fontWeight: isCompleted ? "bold" : "inherit"
                }
              },
              isCompleted ? (_b = activity.reward) == null ? void 0 : _b.earnedValue : (_c = activity.reward) == null ? void 0 : _c.availableValue
            ),
            message
          )
        }
      ),
      showRequired && /* @__PURE__ */ React3.createElement(
        IconText,
        {
          iconProps: {
            icon: activity.iconUrl || "",
            css: { filter: `saturate(${isMissed ? 0 : 1})` }
          },
          text: /* @__PURE__ */ React3.createElement(
            UtilityText2,
            {
              css: {
                typography: "$bodyTwo",
                color: isMissed ? "$onSurfaceTextSubdued" : "inherit"
              }
            },
            formatMessage({ id: "REQUIRED" })
          )
        }
      ),
      /* @__PURE__ */ React3.createElement(
        ActivityDate,
        {
          showDate,
          status: activity.status,
          startDate: activity.startDate,
          endDate: activity.endDate
        }
      ),
      (linkedEntity == null ? void 0 : linkedEntity.text) && /* @__PURE__ */ React3.createElement(
        IconText,
        {
          iconProps: {
            icon: linkedEntity.iconUrl,
            css: { filter: `saturate(${isMissed ? 0 : 1})` }
          },
          text: /* @__PURE__ */ React3.createElement(
            UtilityText2,
            {
              css: {
                typography: "$bodyTwo",
                color: isMissed ? "$onSurfaceTextSubdued" : "inherit"
              }
            },
            linkedEntity.text
          )
        }
      )
    );
  }
);

// src/components/reward-program-activity-card/reward-program-activity-card.component.tsx
import React4 from "react";
import {
  useNavigateLegacy as useNavigate,
  useParamsLegacy as useParams2
} from "@leagueplatform/routing";
import { captureError as captureError3 } from "@leagueplatform/observability";
import { EVENT_NAME as EVENT_NAME2, trackAnalyticsEvent as trackAnalyticsEvent2 } from "@leagueplatform/analytics";
function RewardProgramActivityCard({
  activity,
  compact,
  showDate,
  relatedCampaign
}) {
  const isMobile = useMediaQuery(queryHelpers.down("laptop"));
  const navigate = useNavigate();
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  const { userHealthCampaignId } = useParams2();
  const openActivityDetails = () => {
    if (!activity.id) {
      captureError3(
        new Error(
          `Reward program(campaign id: ${userHealthCampaignId}) activity id not provided`
        )
      );
    }
    trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
      ["product_area" /* PRODUCT_AREA */]: "health journey" /* PRODUCT_AREA_HEALTH_JOURNEY */,
      ["sub_product_area" /* SUB_PRODUCT_AREA */]: "reward programs" /* SUB_PRODUCT_AREA_REWARD_PROGRAMS */,
      ["screen_name" /* SCREEN_NAME */]: "health campaign detail progress" /* SCREEN_NAME_HEALTH_CAMPAIGN_DETAIL_PROGRESS */,
      ["detail" /* DETAIL */]: "view health campaign activity" /* DETAIL_VIEW_HEALTH_CAMPAIGN_ACTIVITY */,
      ["health_campaign_activity_id" /* ACTIVITY_ID */]: activity.activityId,
      ["health_campaign_activity_name" /* ACTIVITY_NAME */]: activity.name,
      ["health_campaign_activity_type" /* ACTIVITY_TYPE */]: activity.type,
      ["health_campaign_activity_status" /* ACTIVITY_STATUS */]: activity.status,
      ["health_campaign_activity_required" /* ACTIVITY_REQUIRED */]: activity.required
    });
    navigate(JOURNEY_ROUTES2.getToolboxActivityDetails(activity.id));
  };
  if (compact && isMobile) {
    return /* @__PURE__ */ React4.createElement(
      Card.Flat,
      {
        css: { width: "100%", paddingTop: "$half", paddingBottom: "$half" }
      },
      /* @__PURE__ */ React4.createElement(
        Card.ClickArea,
        {
          ref: clickAreaRef,
          onCardMouseUp,
          onCardMouseDown
        },
        /* @__PURE__ */ React4.createElement(StackLayout4, { orientation: "horizontal", verticalAlignment: "center" }, /* @__PURE__ */ React4.createElement(
          ActivityCardContent,
          {
            activity,
            showDate,
            relatedCampaign,
            ref: primaryActionRef,
            clickAction: openActivityDetails
          }
        ), /* @__PURE__ */ React4.createElement(Icon3, { icon: "interfaceChevronForward" }))
      )
    );
  }
  return /* @__PURE__ */ React4.createElement(
    Card.Elevated,
    {
      css: {
        width: "100%",
        maxWidth: isMobile ? "100%" : "calc(50% - $oneAndHalf)"
      }
    },
    /* @__PURE__ */ React4.createElement(
      Card.ClickArea,
      {
        css: { padding: "$oneAndHalf" },
        ref: clickAreaRef,
        onCardMouseUp,
        onCardMouseDown
      },
      /* @__PURE__ */ React4.createElement(
        ActivityCardContent,
        {
          activity,
          showDate,
          relatedCampaign,
          ref: primaryActionRef,
          clickAction: openActivityDetails
        }
      )
    )
  );
}

// src/utils/should-display-date.util.ts
function shouldDisplayDate(startDateParent, endDateParent, startDateChild, endDateChild) {
  const startDateParentFormatted = new Date(startDateParent || 0).setUTCHours(
    0,
    0,
    0,
    0
  );
  const startDateChildFormatted = new Date(startDateChild || 0).setUTCHours(
    0,
    0,
    0,
    0
  );
  const endDateParentFormatted = new Date(endDateParent || 0).setUTCHours(
    0,
    0,
    0,
    0
  );
  const endDateChildFormatted = new Date(endDateChild || 0).setUTCHours(
    0,
    0,
    0,
    0
  );
  if (startDateChildFormatted !== startDateParentFormatted || endDateChildFormatted !== endDateParentFormatted) {
    return true;
  }
  return false;
}

// src/components/activity-list-section/activity-list-section.component.tsx
var ActivityListSection = ({
  sectionTitle,
  compact,
  relatedCampaign,
  activities
}) => {
  const isMobile = useMediaQuery2(queryHelpers2.down("laptop"));
  const { campaign } = relatedCampaign;
  return /* @__PURE__ */ React5.createElement(StackLayout5, { spacing: "$one", css: { width: "100%" } }, compact ? /* @__PURE__ */ React5.createElement(
    Box,
    {
      css: {
        padding: "$threeQuarters",
        width: "100%",
        backgroundColor: "$surfaceBackgroundTertiary"
      }
    },
    /* @__PURE__ */ React5.createElement(UtilityText3, { css: { typography: "$overline" } }, sectionTitle)
  ) : /* @__PURE__ */ React5.createElement(HeadingText2, { level: "3", size: "lg" }, sectionTitle), /* @__PURE__ */ React5.createElement(
    StackLayout5,
    {
      divider: compact && isMobile ? /* @__PURE__ */ React5.createElement(
        Box,
        {
          css: {
            width: "100%",
            height: "1px",
            backgroundColor: "$onSurfaceBorderSubdued"
          }
        }
      ) : void 0,
      spacing: compact && isMobile ? "none" : "$oneAndHalf",
      orientation: isMobile ? "vertical" : "horizontal",
      css: {
        width: "100%",
        flexWrap: "wrap",
        paddingInlineStart: compact && isMobile ? "none" : "$threeQuarters",
        paddingBottom: compact && isMobile ? "none" : "$oneAndHalf"
      }
    },
    activities.map((activity) => /* @__PURE__ */ React5.createElement(
      RewardProgramActivityCard,
      {
        key: activity.id,
        relatedCampaign,
        activity,
        compact,
        showDate: shouldDisplayDate(
          campaign.data.startDate,
          campaign.data.endDate,
          activity.startDate,
          activity.endDate
        )
      }
    ))
  ));
};

// src/hooks/use-sort-activities-by-status.hook.ts
import { UserHealthActivityStatus as UserHealthActivityStatus3 } from "@leagueplatform/health-journey-common";
import { useMemo } from "react";
function useSortActivitiesByStatus(activities) {
  const sortedActivities = useMemo(() => {
    const activeActivities = [];
    const missedActivities = [];
    const completedActivities = [];
    activities.forEach((activity) => {
      switch (activity.status) {
        case UserHealthActivityStatus3.ACTIVE:
        case UserHealthActivityStatus3.UPCOMING:
          activeActivities.push(activity);
          break;
        case UserHealthActivityStatus3.EXPIRED:
        case UserHealthActivityStatus3.REMOVED:
          missedActivities.push(activity);
          break;
        case UserHealthActivityStatus3.COMPLETED:
          completedActivities.push(activity);
          break;
        default:
      }
    });
    return { activeActivities, missedActivities, completedActivities };
  }, [activities]);
  return sortedActivities;
}

// src/components/activity-list/activity-list.component.tsx
import React6 from "react";
function ActivityList({ compact, relatedCampaign }) {
  var _a;
  const { activeActivities, completedActivities, missedActivities } = useSortActivitiesByStatus(((_a = relatedCampaign.userHealthActivities) == null ? void 0 : _a.data) || []);
  const { formatMessage } = useIntl4();
  return /* @__PURE__ */ React6.createElement(StackLayout6, { orientation: "vertical", spacing: "$two" }, activeActivities.length > 0 && /* @__PURE__ */ React6.createElement(
    ActivityListSection,
    {
      compact,
      activities: activeActivities,
      relatedCampaign,
      sectionTitle: formatMessage({ id: "ACTIVITIES" })
    }
  ), completedActivities.length > 0 && /* @__PURE__ */ React6.createElement(
    ActivityListSection,
    {
      compact,
      activities: completedActivities,
      relatedCampaign,
      sectionTitle: formatMessage({ id: "COMPLETED_ACTIVITIES" })
    }
  ), missedActivities.length > 0 && /* @__PURE__ */ React6.createElement(
    ActivityListSection,
    {
      compact,
      activities: missedActivities,
      relatedCampaign,
      sectionTitle: formatMessage({ id: "MISSED_ACTIVITIES" })
    }
  ));
}

// src/components/reward-program-group/reward-program-group.component.tsx
import React9, { useState } from "react";
import { Accordion } from "@leagueplatform/web-common-components";
import {
  ProgramBanner,
  ProgramRichText as ProgramRichText2
} from "@leagueplatform/health-journey-common";
import {
  Box as Box2,
  HeadingText as HeadingText3,
  StackLayout as StackLayout9,
  UtilityText as UtilityText6,
  styled as styled2
} from "@leagueplatform/genesis-core";

// src/components/reward-programs-progress/reward-programs-progress.component.tsx
import * as React7 from "react";
import {
  StackLayout as StackLayout7,
  StackItem,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
import { RewardPointsIcon } from "@leagueplatform/rewards-common";
import { ProgressBar } from "@leagueplatform/web-common-components";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
var RewardProgramsProgress = ({
  iconUrl,
  currentValue,
  maxValue,
  showProgress
}) => {
  const { formatNumber, formatMessage } = useIntl5();
  return /* @__PURE__ */ React7.createElement(
    StackLayout7,
    {
      orientation: "vertical",
      verticalAlignment: "center",
      spacing: "$half"
    },
    /* @__PURE__ */ React7.createElement(
      StackLayout7,
      {
        orientation: "horizontal",
        spacing: "$quarter",
        verticalAlignment: "center"
      },
      /* @__PURE__ */ React7.createElement(RewardPointsIcon, { iconUrl, value: currentValue }),
      /* @__PURE__ */ React7.createElement(UtilityText4, { css: { fontSize: "inherit" } }, "/"),
      /* @__PURE__ */ React7.createElement(UtilityText4, { css: { fontSize: "inherit" } }, formatNumber(maxValue)),
      /* @__PURE__ */ React7.createElement(UtilityText4, { css: { fontSize: "inherit" } }, formatMessage({ id: "REWARD_POINTS_EARNED" }))
    ),
    showProgress && /* @__PURE__ */ React7.createElement(StackItem, { css: { width: "100%" } }, /* @__PURE__ */ React7.createElement(
      ProgressBar,
      {
        customBarFillColor: "success.border.default",
        customBarBackgroundColor: "interactive.background.disabled",
        current: currentValue,
        total: maxValue
      }
    ))
  );
};

// src/components/reward-program-group/reward-program-group.component.tsx
import {
  USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS2
} from "@leagueplatform/health-journey-api";

// src/components/program-date/program-date.component.tsx
import React8 from "react";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import { Icon as Icon4, StackLayout as StackLayout8, UtilityText as UtilityText5 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { useGetUserProfile as useGetUserProfile3 } from "@leagueplatform/health-journey-common";
function ProgramDate({ startDate, endDate }) {
  const { formatDate, formatMessage } = useIntl6();
  const { data: userProfileData } = useGetUserProfile3();
  const { defaultTimezone } = userProfileData || {};
  if (!endDate && !startDate)
    return null;
  let dateString;
  if (startDate) {
    dateString = `${formatMessage(
      { id: "START_DAY_AT_TIME" },
      {
        day: formatDate(startDate, {
          month: "long",
          day: "numeric",
          year: "numeric",
          timeZone: defaultTimezone
        })
      }
    )}`;
    if (endDate) {
      dateString = dateString.concat(
        ` \u2022 ${formatMessage(
          { id: "END_DAY_AT_TIME" },
          {
            day: formatDate(endDate, {
              month: "long",
              day: "numeric",
              year: "numeric",
              timeZone: defaultTimezone
            })
          }
        )}`
      );
    }
  } else if (endDate) {
    dateString = formatMessage(
      { id: "ENDED_DAY_AT_TIME" },
      {
        day: formatDate(endDate, {
          month: "long",
          day: "numeric",
          year: "numeric",
          timeZone: defaultTimezone
        })
      }
    );
  }
  return /* @__PURE__ */ React8.createElement(
    StackLayout8,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      spacing: "$quarter"
    },
    /* @__PURE__ */ React8.createElement(
      Icon4,
      {
        css: { filter: `saturate(${startDate ? 1 : 0})` },
        icon: handleStaticAsset2(
          "REWARDS_PROGRAM_CLOCK" /* REWARDS_PROGRAM_CLOCK */
        ),
        size: "$one"
      }
    ),
    /* @__PURE__ */ React8.createElement(
      UtilityText5,
      {
        css: {
          typography: "$bodyTwo",
          color: startDate ? "inherit" : "$onSurfaceTextSubdued"
        }
      },
      dateString
    )
  );
}

// src/components/reward-program-group/reward-program-group.component.tsx
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
import { EVENT_NAME as EVENT_NAME3, trackAnalyticsEvent as trackAnalyticsEvent3 } from "@leagueplatform/analytics";
var StyledAccordionTrigger = styled2(Accordion.Trigger, {
  "&, > span": {
    padding: "$oneAndHalf",
    background: "$surfaceBackgroundSecondary",
    borderRadius: "$large",
    borderWidth: "$thin",
    borderStyle: "solid",
    borderColor: "$onSurfaceBorderSubdued",
    color: "$onSurfaceTextPrimary",
    "> span": {
      flexGrow: 1
    }
  },
  display: "flex",
  width: "100%",
  position: "relative",
  cursor: "pointer",
  textAlign: "start",
  ".accordion-chevron": {
    transition: "transform 0.25s ease"
  },
  '&[aria-expanded="true"] .accordion-chevron': {
    transform: "rotate(180deg)"
  },
  '&[aria-expanded="true"]': {
    "&, > span": {
      borderBottom: "none",
      borderEndStartRadius: 0,
      borderEndEndRadius: 0
    }
  },
  "&:hover": {
    "&, > span": {
      backgroundColor: "$surfaceBackgroundSecondary"
    }
  }
});
var StyledAccordionContent = styled2(Accordion.Content, {
  backgroundColor: "$surfaceBackgroundPrimary",
  borderEndStartRadius: "$large",
  borderEndEndRadius: "$large",
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderSubdued",
  borderTop: "none",
  marginX: 1
});
var RewardProgramGroup = ({
  relatedCampaign,
  showDate
}) => {
  var _a;
  const [groupOpen, setGroupOpen] = useState(false);
  const campaign = relatedCampaign.campaign.data;
  const { status, completedComponentAttributes, campaignProgress } = relatedCampaign;
  const { richTextDescription, name, startDate, endDate } = campaign;
  const showDescription = status !== USER_HEALTH_CAMPAIGN_STATUS2.COMPLETED;
  const showCompletionBanner = status === USER_HEALTH_CAMPAIGN_STATUS2.COMPLETED && completedComponentAttributes;
  const showProgramDate = status === USER_HEALTH_CAMPAIGN_STATUS2.ACTIVE && showDate;
  const handleAccordionChange = () => {
    trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
      ["product_area" /* PRODUCT_AREA */]: "health journey" /* PRODUCT_AREA_HEALTH_JOURNEY */,
      ["sub_product_area" /* SUB_PRODUCT_AREA */]: "reward programs" /* SUB_PRODUCT_AREA_REWARD_PROGRAMS */,
      ["screen_name" /* SCREEN_NAME */]: "health campaign detail progress" /* SCREEN_NAME_HEALTH_CAMPAIGN_DETAIL_PROGRESS */,
      ["detail" /* DETAIL */]: !groupOpen ? "expand" /* EXPAND */ : "collapse" /* COLLAPSE */,
      ["health_campaign_name" /* CAMPAIGN_NAME */]: campaign.name,
      ["health_campaign_id" /* CAMPAIGN_ID */]: relatedCampaign.campaignId,
      ["health_campaign_type" /* CAMPAIGN_TYPE */]: campaign.type,
      ["health_campaign_status" /* CAMPAIGN_STATUS */]: relatedCampaign.status
    });
    setGroupOpen((previous) => !previous);
  };
  return /* @__PURE__ */ React9.createElement(Accordion.Root, { collapsible: true, type: "single", onClick: handleAccordionChange }, /* @__PURE__ */ React9.createElement(Accordion.Item, { value: name }, /* @__PURE__ */ React9.createElement(Accordion.Header, { level: "3", size: "md" }, /* @__PURE__ */ React9.createElement(StyledAccordionTrigger, null, /* @__PURE__ */ React9.createElement(StackLayout9, { spacing: "$half" }, /* @__PURE__ */ React9.createElement(
    HeadingText3,
    {
      level: "display",
      size: "md",
      css: { typography: "$headingThree" }
    },
    name
  ), showDescription && /* @__PURE__ */ React9.createElement(UtilityText6, { css: { typography: "$bodyTwo", p: { margin: 0 } } }, /* @__PURE__ */ React9.createElement(ProgramRichText2, { richText: richTextDescription })), showCompletionBanner && /* @__PURE__ */ React9.createElement(
    ProgramBanner,
    {
      boldedText: {
        iconProps: {
          icon: handleStaticAsset3(
            "REWARDS_PROGRAM_CHECK_MARK" /* REWARDS_PROGRAM_CHECK_MARK */
          ),
          tint: "$successIcon",
          size: 16
        },
        text: /* @__PURE__ */ React9.createElement(
          HeadingText3,
          {
            level: "3",
            size: "md",
            css: {
              color: "$onSurfaceTextSuccess",
              fontWeight: 600
            }
          },
          completedComponentAttributes.componentAttributes.title
        )
      },
      basicText: /* @__PURE__ */ React9.createElement(
        ProgramRichText2,
        {
          richText: (_a = completedComponentAttributes.componentAttributes) == null ? void 0 : _a.richText
        }
      ),
      css: {
        width: "calc(100% + $one)",
        backgroundColor: "$successBackgroundSecondary",
        borderRadius: "$medium",
        padding: "$one",
        textAlign: "center",
        typography: "$caption"
      },
      horizontalAlignment: "center"
    }
  ), /* @__PURE__ */ React9.createElement(Box2, { css: { typography: "$bodyTwo", marginTop: "$half" } }, /* @__PURE__ */ React9.createElement(
    RewardProgramsProgress,
    {
      iconUrl: campaignProgress.iconUrl,
      currentValue: campaignProgress.current,
      maxValue: campaignProgress.threshold,
      showProgress: false
    }
  )), showProgramDate && /* @__PURE__ */ React9.createElement(ProgramDate, { startDate, endDate })))), /* @__PURE__ */ React9.createElement(StyledAccordionContent, { css: { marginTop: "$minusQuarter" } }, /* @__PURE__ */ React9.createElement(ActivityList, { compact: true, relatedCampaign }))));
};

// src/components/reward-program-tier/reward-program-tier.component.tsx
import {
  Box as Box3,
  Card as Card2,
  HeadingText as HeadingText4,
  StackLayout as StackLayout10,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
import {
  USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS3
} from "@leagueplatform/health-journey-api";
import {
  ProgramBanner as ProgramBanner2,
  ProgramRichText as ProgramRichText3
} from "@leagueplatform/health-journey-common";
import React10 from "react";
function RewardProgramTier({
  relatedCampaign,
  showDate
}) {
  var _a;
  const {
    campaign,
    userHealthCampaigns,
    userHealthActivities,
    campaignProgress
  } = relatedCampaign;
  const completedComponentAttributes = (_a = relatedCampaign.completedComponentAttributes) == null ? void 0 : _a.componentAttributes;
  const showCompletionBanner = relatedCampaign.status === USER_HEALTH_CAMPAIGN_STATUS3.COMPLETED && completedComponentAttributes;
  const showProgramDate = relatedCampaign.status !== USER_HEALTH_CAMPAIGN_STATUS3.COMPLETED && showDate;
  const showActivities = userHealthActivities;
  const showGroups = Array.isArray(userHealthCampaigns == null ? void 0 : userHealthCampaigns.data);
  return /* @__PURE__ */ React10.createElement(StackLayout10, { horizontalAlignment: "stretch", spacing: "$one" }, /* @__PURE__ */ React10.createElement(HeadingText4, { level: "2", size: "xl" }, campaign.data.name), showCompletionBanner && /* @__PURE__ */ React10.createElement(Card2.Flat, { css: { backgroundColor: "$successBackgroundSubdued" } }, /* @__PURE__ */ React10.createElement(Card2.Section, null, /* @__PURE__ */ React10.createElement(
    ProgramBanner2,
    {
      icon: completedComponentAttributes.iconUrl,
      basicText: /* @__PURE__ */ React10.createElement(
        ProgramRichText3,
        {
          richText: completedComponentAttributes.richText
        }
      )
    }
  ))), relatedCampaign.status === USER_HEALTH_CAMPAIGN_STATUS3.ACTIVE && /* @__PURE__ */ React10.createElement(UtilityText7, { css: { typography: "$bodyOne" } }, /* @__PURE__ */ React10.createElement(ProgramRichText3, { richText: campaign.data.richTextDescription })), /* @__PURE__ */ React10.createElement(Box3, { css: { typography: "$bodyTwo" } }, /* @__PURE__ */ React10.createElement(
    RewardProgramsProgress,
    {
      iconUrl: campaignProgress.iconUrl,
      currentValue: campaignProgress.current,
      maxValue: campaignProgress.threshold,
      showProgress: true
    }
  )), showProgramDate && /* @__PURE__ */ React10.createElement(
    ProgramDate,
    {
      startDate: campaign.data.startDate,
      endDate: campaign.data.endDate
    }
  ), showGroups && (userHealthCampaigns == null ? void 0 : userHealthCampaigns.data.map((group) => /* @__PURE__ */ React10.createElement(
    RewardProgramGroup,
    {
      key: group.id,
      showDate: shouldDisplayDate(
        campaign.data.startDate,
        campaign.data.endDate,
        group.campaign.data.startDate,
        group.campaign.data.endDate
      ),
      relatedCampaign: group
    }
  ))), showActivities && /* @__PURE__ */ React10.createElement(ActivityList, { relatedCampaign }));
}

// src/components/reward-program-progress-tab/reward-program-progress-tab.component.tsx
import React11, { useEffect as useEffect2 } from "react";
function RewardProgramProgressTab({
  rewardProgram,
  isVisible
}) {
  const { userHealthCampaigns, campaign, userHealthActivities } = rewardProgram;
  const { displayGlobalProgress } = campaign.data;
  const campaignsArrayExists = Array.isArray(userHealthCampaigns == null ? void 0 : userHealthCampaigns.data);
  const showGroups = campaignsArrayExists && displayGlobalProgress;
  const showTiers = campaignsArrayExists && !displayGlobalProgress;
  const showActivities = Array.isArray(userHealthActivities == null ? void 0 : userHealthActivities.data);
  useEffect2(() => {
    if (!showGroups && !showTiers && !showActivities) {
      captureError4(
        new Error(
          `Reward program(id:${rewardProgram.id}) progress data isn't provided`
        )
      );
    }
  }, []);
  useEffect2(() => {
    if (isVisible) {
      trackAnalyticsEvent4(EVENT_NAME4.SCREEN_LOADED, {
        ["product_area" /* PRODUCT_AREA */]: "health journey" /* PRODUCT_AREA_HEALTH_JOURNEY */,
        ["sub_product_area" /* SUB_PRODUCT_AREA */]: "reward programs" /* SUB_PRODUCT_AREA_REWARD_PROGRAMS */,
        ["screen_name" /* SCREEN_NAME */]: "health campaign detail progress" /* SCREEN_NAME_HEALTH_CAMPAIGN_DETAIL_PROGRESS */,
        ["health_campaign_name" /* CAMPAIGN_NAME */]: campaign.data.name,
        ["health_campaign_id" /* CAMPAIGN_ID */]: rewardProgram.campaignId,
        ["health_campaign_type" /* CAMPAIGN_TYPE */]: campaign.data.type,
        ["health_campaign_status" /* CAMPAIGN_STATUS */]: rewardProgram.status
      });
    }
  }, [
    campaign.data.name,
    campaign.data.type,
    isVisible,
    rewardProgram.campaignId,
    rewardProgram.status
  ]);
  return /* @__PURE__ */ React11.createElement(
    StackLayout11,
    {
      css: { marginTop: "$two" },
      horizontalAlignment: "stretch",
      spacing: "$two",
      divider: showTiers ? /* @__PURE__ */ React11.createElement(
        Box4,
        {
          css: {
            height: "$one",
            width: "100%",
            background: "$interactiveActionDisabled"
          }
        }
      ) : void 0
    },
    showTiers && (userHealthCampaigns == null ? void 0 : userHealthCampaigns.data.map((tier) => /* @__PURE__ */ React11.createElement(
      RewardProgramTier,
      {
        key: tier.id,
        showDate: shouldDisplayDate(
          campaign.data.startDate,
          campaign.data.endDate,
          tier.campaign.data.startDate,
          tier.campaign.data.endDate
        ),
        relatedCampaign: tier
      }
    ))),
    showGroups && (userHealthCampaigns == null ? void 0 : userHealthCampaigns.data.map((group) => /* @__PURE__ */ React11.createElement(
      RewardProgramGroup,
      {
        key: group.id,
        showDate: shouldDisplayDate(
          campaign.data.startDate,
          campaign.data.endDate,
          group.campaign.data.startDate,
          group.campaign.data.endDate
        ),
        relatedCampaign: group
      }
    ))),
    showActivities && /* @__PURE__ */ React11.createElement(ActivityList, { relatedCampaign: rewardProgram })
  );
}

// src/components/reward-program-sidebar/reward-program-sidebar.component.tsx
import { Box as Box5, StackLayout as StackLayout13 } from "@leagueplatform/genesis-core";
import {
  ProgramDetailCard,
  ProgramDetailCardFooter,
  ProgramRichText as ProgramRichText4
} from "@leagueplatform/health-journey-common";
import { useIntl as useIntl9 } from "@leagueplatform/locales";

// src/components/header-date/header-date.component.tsx
import {
  Icon as Icon5,
  Responsive,
  StackLayout as StackLayout12,
  StatusBadge,
  UtilityText as UtilityText8,
  queryHelpers as queryHelpers3,
  useMediaQuery as useMediaQuery3
} from "@leagueplatform/genesis-core";
import { useGetUserProfile as useGetUserProfile4 } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import React12 from "react";

// src/hooks/use-program-status-styles.ts
import { USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS4 } from "@leagueplatform/health-journey-api";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
var useProgramStatusStyles = (status, dateCompleted, timeZone) => {
  const { formatMessage, formatDate } = useIntl7();
  switch (status) {
    case USER_HEALTH_CAMPAIGN_STATUS4.ENDED:
      return {
        badgeStatus: "error",
        text: formatMessage({ id: "ENDED" })
      };
    case USER_HEALTH_CAMPAIGN_STATUS4.COMPLETED:
      return {
        badgeStatus: "neutral",
        text: formatMessage(
          {
            id: "COMPLETED_ON_DATE"
          },
          {
            date: formatDate(dateCompleted, {
              month: "long",
              day: "numeric",
              year: "numeric",
              timeZone
            })
          }
        )
      };
    case USER_HEALTH_CAMPAIGN_STATUS4.ACTIVE:
      return {
        badgeStatus: "success",
        text: formatMessage({ id: "ACTIVE" })
      };
    default:
      return {
        badgeStatus: "success",
        text: formatMessage({ id: "ACTIVE" })
      };
  }
};

// src/components/header-date/header-date.component.tsx
var HeaderDate = ({
  startDate,
  endDate,
  status,
  dateCompleted
}) => {
  const isMobile = useMediaQuery3(queryHelpers3.down("laptop"));
  const { data: userProfileData } = useGetUserProfile4();
  const { defaultTimezone } = userProfileData || {};
  const { text: badgeText, badgeStatus } = useProgramStatusStyles(
    status,
    dateCompleted,
    defaultTimezone
  );
  const { formatMessage, formatDate } = useIntl8();
  return /* @__PURE__ */ React12.createElement(StackLayout12, { orientation: "horizontal", spacing: "$one" }, /* @__PURE__ */ React12.createElement(Responsive, { up: "laptop" }, /* @__PURE__ */ React12.createElement(Icon5, { icon: "descriptiveCalendar", size: "$oneAndHalf" })), /* @__PURE__ */ React12.createElement(
    StackLayout12,
    {
      css: { flexWrap: "wrap" },
      horizontalAlignment: isMobile ? "center" : "start",
      orientation: isMobile ? "horizontal" : "vertical",
      verticalAlignment: "center",
      spacing: "$quarter"
    },
    /* @__PURE__ */ React12.createElement(
      UtilityText8,
      {
        css: {
          typography: isMobile ? "$bodyTwo" : "$bodyOne"
        }
      },
      formatMessage(
        { id: "START_DAY_AT_TIME" },
        {
          day: formatDate(startDate, {
            month: "long",
            day: "numeric",
            year: "numeric",
            timeZone: defaultTimezone
          })
        }
      )
    ),
    endDate && isMobile && /* @__PURE__ */ React12.createElement(
      UtilityText8,
      {
        css: {
          typography: isMobile ? "$bodyTwo" : "$bodyOne"
        }
      },
      "\u2022"
    ),
    endDate && /* @__PURE__ */ React12.createElement(
      UtilityText8,
      {
        css: {
          typography: isMobile ? "$bodyTwo" : "$bodyOne"
        }
      },
      formatMessage(
        { id: "END_DAY_AT_TIME" },
        {
          day: formatDate(endDate, {
            month: "long",
            day: "numeric",
            year: "numeric",
            timeZone: defaultTimezone
          })
        }
      )
    ),
    /* @__PURE__ */ React12.createElement(
      StatusBadge,
      {
        css: {
          marginTop: isMobile ? "none" : "threeQuarters",
          marginInlineStart: isMobile ? "one" : "none"
        },
        label: badgeText,
        showLight: true,
        status: badgeStatus
      }
    )
  ));
};

// src/components/reward-program-sidebar/reward-program-sidebar.component.tsx
import React13 from "react";
function RewardProgramSideBar({
  rewardProgram
}) {
  var _a;
  const { formatMessage } = useIntl9();
  const { campaign, campaignProgress } = rewardProgram;
  const endedComponentAttributes = (_a = rewardProgram.endedComponentAttributes) == null ? void 0 : _a.componentAttributes;
  const showVisibilityBanner = new Date(rewardProgram == null ? void 0 : rewardProgram.visibilityEndDate) > /* @__PURE__ */ new Date() && new Date(rewardProgram == null ? void 0 : rewardProgram.campaign.data.endDate) < /* @__PURE__ */ new Date() && endedComponentAttributes;
  return /* @__PURE__ */ React13.createElement(StackLayout13, { spacing: "$oneAndHalf" }, campaign.data.displayGlobalProgress && /* @__PURE__ */ React13.createElement(ProgramDetailCard, { heading: formatMessage({ id: "PROGRAM_PROGRESS" }) }, /* @__PURE__ */ React13.createElement(Box5, { css: { fontSize: "$bodyOne" } }, /* @__PURE__ */ React13.createElement(
    RewardProgramsProgress,
    {
      iconUrl: campaignProgress == null ? void 0 : campaignProgress.iconUrl,
      currentValue: campaignProgress == null ? void 0 : campaignProgress.current,
      maxValue: campaignProgress == null ? void 0 : campaignProgress.threshold,
      showProgress: true
    }
  ))), /* @__PURE__ */ React13.createElement(
    ProgramDetailCard,
    {
      heading: formatMessage({ id: "PROGRAM_DETAILS" }),
      footer: showVisibilityBanner && endedComponentAttributes && /* @__PURE__ */ React13.createElement(
        ProgramDetailCardFooter,
        {
          boldedText: endedComponentAttributes.title,
          basicText: /* @__PURE__ */ React13.createElement(ProgramRichText4, { richText: endedComponentAttributes.richText }),
          icon: endedComponentAttributes.iconUrl
        }
      )
    },
    /* @__PURE__ */ React13.createElement(
      HeaderDate,
      {
        startDate: campaign.data.startDate,
        endDate: campaign.data.endDate,
        dateCompleted: rewardProgram.completionDate,
        status: rewardProgram.status
      }
    )
  ));
}

// src/components/reward-program-header/reward-program-header.component.tsx
import {
  Box as Box6,
  Card as Card3,
  ParagraphText,
  queryHelpers as queryHelpers4,
  useMediaQuery as useMediaQuery4
} from "@leagueplatform/genesis-core";
import {
  USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS5
} from "@leagueplatform/health-journey-api";
import {
  ProgramBanner as ProgramBanner3,
  ProgramDetailCard as ProgramDetailCard2,
  ProgramHeading,
  ProgramRichText as ProgramRichText5
} from "@leagueplatform/health-journey-common";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import { captureError as captureError5 } from "@leagueplatform/observability";
import React14, { useEffect as useEffect3 } from "react";
function RewardProgramHeader({
  rewardProgram
}) {
  var _a;
  const { formatMessage } = useIntl10();
  const { campaign, campaignProgress } = rewardProgram;
  const isMobile = useMediaQuery4(queryHelpers4.down("laptop"));
  const completedComponentAttributes = (_a = rewardProgram.completedComponentAttributes) == null ? void 0 : _a.componentAttributes;
  const showCompletionBanner = campaign.data.displayGlobalProgress && completedComponentAttributes && rewardProgram.status === USER_HEALTH_CAMPAIGN_STATUS5.COMPLETED;
  const showCampaignProgress = campaignProgress && campaign.data.displayGlobalProgress && isMobile;
  useEffect3(() => {
    if (!rewardProgram.status && !campaign.data.name && !campaign.data.programImage) {
      captureError5(
        new Error(
          `Reward program(id:${rewardProgram.id}) wasn't configured properly`
        )
      );
    }
  }, [
    campaign.data.name,
    campaign.data.programImage,
    rewardProgram.id,
    rewardProgram.status
  ]);
  return /* @__PURE__ */ React14.createElement(
    ProgramHeading,
    {
      badge: {
        css: { borderRadius: "$medium" },
        iconTextProps: {
          iconProps: {
            tint: "$decorativeBrandSecondaryDefault",
            icon: campaign.data.programHeaderIcon,
            size: "16px"
          },
          text: /* @__PURE__ */ React14.createElement(ParagraphText, { css: { typography: "$overline" } }, campaign.data.programHeader)
        }
      },
      image: campaign.data.programImage,
      title: campaign.data.name
    },
    isMobile && /* @__PURE__ */ React14.createElement(
      HeaderDate,
      {
        startDate: campaign.data.startDate,
        endDate: campaign.data.endDate,
        dateCompleted: rewardProgram.completionDate,
        status: rewardProgram.status
      }
    ),
    showCompletionBanner && /* @__PURE__ */ React14.createElement(Card3.Flat, { css: { backgroundColor: "$successBackgroundSubdued" } }, /* @__PURE__ */ React14.createElement(Card3.Section, null, /* @__PURE__ */ React14.createElement(
      ProgramBanner3,
      {
        icon: completedComponentAttributes.iconUrl,
        basicText: /* @__PURE__ */ React14.createElement(
          ProgramRichText5,
          {
            richText: completedComponentAttributes.richText
          }
        )
      }
    ))),
    showCampaignProgress && /* @__PURE__ */ React14.createElement(
      ProgramDetailCard2,
      {
        backgroundColor: "$surfaceBackgroundTertiary",
        heading: formatMessage({ id: "PROGRAM_PROGRESS" })
      },
      /* @__PURE__ */ React14.createElement(Box6, { css: { fontSize: "$bodyOne" } }, /* @__PURE__ */ React14.createElement(
        RewardProgramsProgress,
        {
          iconUrl: campaignProgress.iconUrl,
          currentValue: campaignProgress.current,
          maxValue: campaignProgress.threshold,
          showProgress: true
        }
      ))
    )
  );
}

// src/pages/reward-program-landing-page/reward-program-landing-page.component.tsx
import { EVENT_NAME as EVENT_NAME5, trackAnalyticsEvent as trackAnalyticsEvent5 } from "@leagueplatform/analytics";

// src/hooks/use-get-current-tab.hook.ts
import { useUrlParam } from "@leagueplatform/web-common";
import { useMemo as useMemo2 } from "react";
function useGetCurrentTab(rewardProgram) {
  const { urlParam } = useUrlParam("page");
  return useMemo2(() => {
    if (!rewardProgram)
      return void 0;
    const { userHealthCampaigns, campaign } = rewardProgram;
    const { displayGlobalProgress } = campaign.data;
    if (urlParam)
      return urlParam;
    if (displayGlobalProgress && rewardProgram.campaignProgress.current > 0) {
      return "progress" /* PROGRESS */;
    }
    if (!displayGlobalProgress) {
      let hasProgress = false;
      userHealthCampaigns == null ? void 0 : userHealthCampaigns.data.forEach((childCampaign) => {
        if (childCampaign.campaignProgress.current > 0)
          hasProgress = true;
      });
      if (hasProgress)
        return "progress" /* PROGRESS */;
    }
    return "overview" /* OVERVIEW */;
  }, [rewardProgram, urlParam]);
}

// src/pages/reward-program-landing-page/reward-program-landing-page.component.tsx
import { useNavigateLegacy as useNavigate2 } from "@leagueplatform/routing";
var RewardProgramLandingPage = () => {
  var _a;
  const { isLoading, rewardProgram, isError, error } = useRewardProgramLandingPage();
  const { formatMessage } = useIntl11();
  const currentTab = useGetCurrentTab(rewardProgram);
  const navigate = useNavigate2();
  if (isError) {
    return /* @__PURE__ */ React15.createElement(FullPageError, { error, route: JOURNEY_ROUTES3.journeyHome() });
  }
  if (isLoading || !rewardProgram) {
    return /* @__PURE__ */ React15.createElement(LoadingIndicator, null);
  }
  const { campaign } = rewardProgram;
  const endedComponentAttributes = (_a = rewardProgram.endedComponentAttributes) == null ? void 0 : _a.componentAttributes;
  const showVisibilityBanner = new Date(rewardProgram == null ? void 0 : rewardProgram.visibilityEndDate) > /* @__PURE__ */ new Date() && new Date(rewardProgram == null ? void 0 : rewardProgram.campaign.data.endDate) < /* @__PURE__ */ new Date() && endedComponentAttributes;
  return /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(
    ProgramLayout,
    {
      header: /* @__PURE__ */ React15.createElement(RewardProgramHeader, { rewardProgram }),
      content: /* @__PURE__ */ React15.createElement(
        ProgramTabs,
        {
          currentTab,
          tabs: [
            {
              tabContent: /* @__PURE__ */ React15.createElement(
                RewardProgramOverviewTab,
                {
                  campaignId: rewardProgram.id,
                  campaign,
                  status: rewardProgram.status
                }
              ),
              tabName: formatMessage({ id: "OVERVIEW" }),
              tabKey: "overview" /* OVERVIEW */,
              onClick: () => {
                navigate({ search: `?page=${"overview" /* OVERVIEW */}` });
                trackAnalyticsEvent5(EVENT_NAME5.BUTTON_CLICKED, {
                  ["product_area" /* PRODUCT_AREA */]: "health journey" /* PRODUCT_AREA_HEALTH_JOURNEY */,
                  ["sub_product_area" /* SUB_PRODUCT_AREA */]: "reward programs" /* SUB_PRODUCT_AREA_REWARD_PROGRAMS */,
                  ["screen_name" /* SCREEN_NAME */]: "health campaign detail" /* SCREEN_NAME_HEALTH_CAMPAIGN_DETAIL */,
                  ["detail" /* DETAIL */]: "navigation tab clicked" /* DETAIL_NAVIGATION_TAB_CLICKED */,
                  ["sub_detail" /* SUB_DETAIL */]: "overview" /* OVERVIEW */,
                  ["health_campaign_name" /* CAMPAIGN_NAME */]: campaign.data.name,
                  ["health_campaign_id" /* CAMPAIGN_ID */]: rewardProgram.campaignId,
                  ["health_campaign_type" /* CAMPAIGN_TYPE */]: campaign.data.type,
                  ["health_campaign_status" /* CAMPAIGN_STATUS */]: rewardProgram.status
                });
              }
            },
            {
              tabContent: /* @__PURE__ */ React15.createElement(RewardProgramProgressTab, { rewardProgram }),
              tabName: formatMessage({ id: "PROGRESS" }),
              tabKey: "progress" /* PROGRESS */,
              onClick: () => {
                navigate({ search: `?page=${"progress" /* PROGRESS */}` });
                trackAnalyticsEvent5(EVENT_NAME5.BUTTON_CLICKED, {
                  ["product_area" /* PRODUCT_AREA */]: "health journey" /* PRODUCT_AREA_HEALTH_JOURNEY */,
                  ["sub_product_area" /* SUB_PRODUCT_AREA */]: "reward programs" /* SUB_PRODUCT_AREA_REWARD_PROGRAMS */,
                  ["screen_name" /* SCREEN_NAME */]: "health campaign detail" /* SCREEN_NAME_HEALTH_CAMPAIGN_DETAIL */,
                  ["detail" /* DETAIL */]: "navigation tab clicked" /* DETAIL_NAVIGATION_TAB_CLICKED */,
                  ["sub_detail" /* SUB_DETAIL */]: "progress" /* PROGRESS */,
                  ["health_campaign_name" /* CAMPAIGN_NAME */]: campaign.data.name,
                  ["health_campaign_id" /* CAMPAIGN_ID */]: rewardProgram.campaignId,
                  ["health_campaign_type" /* CAMPAIGN_TYPE */]: campaign.data.type,
                  ["health_campaign_status" /* CAMPAIGN_STATUS */]: rewardProgram.status
                });
              }
            }
          ]
        }
      ),
      sidebar: /* @__PURE__ */ React15.createElement(RewardProgramSideBar, { rewardProgram })
    }
  ), showVisibilityBanner && /* @__PURE__ */ React15.createElement(Responsive2, { down: "laptop" }, /* @__PURE__ */ React15.createElement(
    Box7,
    {
      css: {
        width: "100%",
        position: "fixed",
        bottom: 0,
        padding: "$one",
        backgroundColor: "$warningBackgroundSubdued",
        zIndex: 1
      }
    },
    /* @__PURE__ */ React15.createElement(
      ProgramBanner4,
      {
        boldedText: endedComponentAttributes.title,
        basicText: /* @__PURE__ */ React15.createElement(ProgramRichText6, { richText: endedComponentAttributes.richText }),
        icon: endedComponentAttributes.iconUrl
      }
    )
  )));
};

// src/index.ts
initModule();
export {
  RewardProgramLandingPage
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/rewards-programs'] = window.leagueSDKsPresent['@leagueplatform/rewards-programs'] || [];
    window.leagueSDKsPresent['@leagueplatform/rewards-programs'].push('2.25.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/rewards-programs'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/rewards-programs module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map